<template>
    <HeaderNav :is_dialogpage="false" :routername="this.$route.name" :addoredirtname="'0'"></HeaderNav>
    <div id="productpage">
       <div class="con_top">
          <button @click="addshow"  v-if="myContrArr.includes(4)" >新增</button>
       </div>

       <div class="serchbox">
            <div class="serch_form">
                        <div class="serch_item">
                           <label>房间名称：</label>
                           <input type="text" placeholder="请输入房间名称" v-model="queryParams.roomName" @keyup.enter="handleSearch">
                        </div>
                        <div class="serch_item">
                           <label>房间分类：</label>
                           <select v-model="queryParams.roomType">
                              <option value="">全部</option>
                              <option v-for="item in categoryList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                        </div>
                        <div class="serch_item">
                           <label>房间床型：</label>
                           <select v-model="queryParams.roomBedType">
                              <option value="">全部</option>
                              <option v-for="item in produtBedTypeList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                        </div>
                        <div class="serch_item">
                           <label>房间窗型：</label>
                           <select v-model="queryParams.roomWindowType">
                              <option value="">全部</option>
                              <option v-for="item in produtWindowTypeList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                        </div>
                        <div class="serch_item">
                           <label>房间状态：</label>
                           <select v-model="queryParams.roomStatus">
                              <option value="">全部</option>
                              <option v-for="item in roomStatusList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                        </div>
             </div>
            <div class="serch_btn">
               <a href="javascript:void(0)" class="btn-search" @click="handleSearch">查询</a>
               <a href="javascript:void(0)" class="btn-reset" @click="handleReset">重置</a>
            </div>
       </div>

       
       <div class="tablelist">
          <div class="content">
                     <div class="tablebox">
                                 <div class="item" v-for="item in this.productList" :class="getClassName(item.roomStatus)">
                                                <div class="imgbox">
                                                      <img :src="item.roomPic" @click="showimg(item.roomPic)">
                                                </div>
                                                <div class="roomStatus">{{ item.roomStatusName }}</div>
                                                <div class="room-info">
                                                    <div class="roomName">{{ item.roomName }}</div>
                                                    <div class="otherInfo">{{getRoomTypeString(item.roomType) }} |
                                                       {{ getRoomWindowTypeString(item.roomWindowType) }} |
                                                       {{ getRoomBedTypeString(item.roomBedType) }} | {{ item.roomArea }}m&sup2;
                                                    </div>
                                                    <div class="orderinfo">
                                                       <div class="pice">￥<font>{{ formatPrice(item.roomPice) }}</font></div>
                                                    </div>
                                                </div>
                                                <div class="btnbox">
                                                     <a href="javascript:void(0)" v-if="myContrArr.includes(5)" class="btn-edit" @click="edirtshow(item.roomId)">编辑</a>
                                                     <a href="javascript:void(0)" v-if="myContrArr.includes(6)" class="btn-del" @click="deleteProduct(item.roomId)">删除</a>
                                                     <a href="javascript:void(0)" v-if="myContrArr.includes(7)" class="btn-select" @click="selectShow(item.roomId)">查看</a>
                                                     <a href="javascript:void(0)" v-if="item.roomStatus != 1&& myContrArr.includes(8) " class="btn-open" @click="upRoomStatus(item.roomId,1)">上架</a>
                                                     <a href="javascript:void(0)" v-if="item.roomStatus !=0 && myContrArr.includes(9)" class="btn-close" @click="upRoomStatus(item.roomId,0)">下架</a>
                                                     <a href="javascript:void(0)" v-if="item.roomStatus != 2 && myContrArr.includes(10)" class="btn-none" @click="upRoomStatus(item.roomId,2)">售罄</a>
                                                </div>
                                 </div>
                                 <div class="no_date" v-if="this.productList.length == 0 ">
                                    暂无数据
                                 </div>
                  </div> 
             </div>
              <div class="footer" v-if="pagesTotal > 1">
                  <div class="pagebtn">
                     <a href="javascript:void(0)" @click="prepage()" class="prebtn">上一页</a>
                     <a href="javascript:void(0)" 
                        v-for="item in pagebtnList" 
                        :key="item"
                        @click="pageselect(item)" 
                        :class="{'active_page': pageNum == item, 'is_sheng': item == '...'}">
                        {{ item }}
                     </a>
                     <a href="javascript:void(0)" @click="nextpage()" class="nextbtn">下一页</a>
                  </div>
             </div>
          </div>
       </div>
     <!-- 图片全屏预览 -->
  <div id="showimgbox" v-if="showimg_src" @click.self="closeshowimgbox">
      <a href="javascript:void(0);" @click="closeshowimgbox">关闭</a>
      <img 
          :src="showimg_src" 
          @load="loadimgfun" 
          ref="imageElement"
          :style="{
              width: show_img_width + 'px',
              height: show_img_height + 'px',
              marginTop: (0 - (show_img_height / 2)) + 'px',
              marginLeft: (0 - (show_img_width / 2)) + 'px'
          }"
      >
  </div>
    <RoomAdd v-if="is_show" :is_edirt="is_edirt" :roomId="currentProductId" @closepage="closepage(0)" @closerush="closepage(1)"></RoomAdd>
    <Roomselect v-if="is_select"  :roomId="currentProductId" @closepage="closeSelect()"></Roomselect>
 </template>
 
 <script>
 import { ElMessage, ElMessageBox } from 'element-plus';
 import HeaderNav from '../common/HeaderNav.vue';
 import RoomAdd  from './RoomAdd.vue'; 
 import Roomselect from './Roomselect.vue';
 // 请根据实际 Api.js 路径引入接口
 import { selectRoomListPage, findMenuContrByMenuId,deleteRoom,updateRoomState } from "@/tools/Api"; 
 
 export default {
    name: "ProductManager",
    components: {
       HeaderNav,
       RoomAdd,
       Roomselect
    },
    data() {
       return {
          myMenuCode: 3, 
          myContrArr: [], 
          
          is_show: false,
          is_select: false,
          is_edirt: false,
          currentProductId: "",
          
          productList: [],
          
          // Pagination parameters
          pageNum: 1,
          pageSize: 10,
          pagesTotal: 0,
          total: 0,
          pagebtnList: [],

          // 【新增】统一管理搜索参数的对象
          queryParams: {
             roomName: '',
             roomType: '',
             roomBedType: '',
             roomWindowType: '',
             roomStatus: ''
          },
          
          // 房间分类列表
          categoryList: [
               { id: 1, name: "大床房" },
               { id: 2, name: "主题房" },
               { id: 3, name: "标间" },
               { id: 4, name: "单间" }
           ],
            // 房间床型列表
            produtBedTypeList: [
               { id: 1, name: "大床" },
               { id: 2, name: "小床" },
               { id: 3, name: "单人床" },
               { id: 4, name: "双人床" },
               { id: 5, name: "混合" }
           ],
           produtWindowTypeList:[
               { id: 1, name: "有窗" },
               { id: 2, name: "无窗" },
               { id: 3, name: "部分有窗" }
           ],
           roomStatusList:[
                { id: 0, name: "下架" },
               { id: 1, name: "上架" },
               { id: 2, name: "售罄" }
           ],
           // 预览状态
          showimg_src: "",
          show_img_width: 0,
          show_img_height: 0
       }
    },
    mounted() {
       this.btnListfind();
       this.getPageList();
    },
    methods: {
      getRoomStatusString(status){
         let name = "";
         this.roomStatusList.forEach(item => {
            if(item.id == status){
               name = item.name
               return 
            }
         })
         return name
      },
      upRoomStatus(id,status){
         ElMessageBox.confirm('该房间将进行'+this.getRoomStatusString(status)+'操作, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            updateRoomState({
               roomId: id,
               roomStatus: status
            }).then(res => {
               if (res.status == 0) {
                  ElMessage({
                     message: "操作成功！",
                     type: 'success',
                     duration: 1500
                  });
                  this.getPageList();
               }else{
                  ElMessage({
                     message: res.msg || "操作失败",
                  })
               }
            }).catch(error => {
               ElMessage({
                  message: "请求失败！",
                  type: 'error',
                  duration: 1500
               });
            });
         }).catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消操作'
            });
         });

         
      },
       // Get permission buttons
       btnListfind() {
          findMenuContrByMenuId(this.myMenuCode).then(res => {
             if (res.status == 0) {
                this.myContrArr = res.data;
             } else {
                ElMessage({ message: "获取权限失败！", type: 'error', duration: 1500 });
             }
          }).catch(error => {
             ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
          });
       },
       selectShow(id){
         this.is_select = true;
         this.currentProductId = id;
       },
       closeSelect(){
          this.is_select = false;
          this.currentProductId = "";
       },
 
       // 【修改】获取列表数据，传入搜索参数
       getPageList() {
         // 构建请求参数，合并分页和搜索条件
         const params = {
             pageNum: this.pageNum,
             pageSize: this.pageSize,
             ...this.queryParams // 展开搜索参数
         };

         selectRoomListPage(params).then(res => {
             if (res.status == 0) {
                this.productList = res.data.list;
                this.pageNum = res.data.pageNum;
                this.pagesTotal = res.data.pages;
                this.total = res.data.total;
                this.pageshowbtn();
                console.log(this.productList);
             }
          }).catch(err => {
             ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
          });
       },

       // 【新增】搜索处理方法
       handleSearch() {
          this.pageNum = 1; // 搜索时重置页码为1
          this.getPageList();
       },

       // 【新增】重置处理方法
       handleReset() {
          // 重置所有搜索条件
          this.queryParams = {
             roomName: '',
             roomType: '',
             roomBedType: '',
             roomWindowType: '',
             roomStatus: ''
          };
          this.handleSearch(); // 重置后重新查询
       },
 
       // Add
       addshow() {
          this.is_show = true;
          this.is_edirt = false;
          this.currentProductId = "";
       },
 
       // Edit
       edirtshow(id) {
          this.currentProductId = id;
          this.is_edirt = true;
          this.is_show = true;
       },
 
       // Close modal callback
       closepage(isrush) {
          if (isrush == 1) {
             this.getPageList(); // 建议刷新列表以显示最新数据
          }
          this.is_edirt = false;
          this.is_show = false;
          this.currentProductId = "";
       },
 
       // Delete
       deleteProduct(id) {
          ElMessageBox.confirm('确认是否删除该商品?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
          }).then(() => {
             deleteRoom(id).then(res => {
                if (res.status == 0) {
                   ElMessage({ message: "删除成功！", type: 'success', duration: 1500 });
                   this.getPageList();
                } else {
                   ElMessage({ message: res.msg, type: 'error', duration: 1500 });
                }
             }).catch(error => {
                ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
             });
          }).catch(() => {});
       },
 
       // Generate pagination button list
       pageshowbtn() {
          this.pagebtnList = [];
          if (this.pagesTotal < 7) {
             for (var i = 0; i < this.pagesTotal; i++) {
                this.pagebtnList.push(i + 1);
             }
          } else {
             if (this.pageNum < 5) {
                this.pagebtnList = [1, 2, 3, 4, 5, '...', this.pagesTotal];
             } else if (this.pageNum > this.pagesTotal - 5) {
                this.pagebtnList = [1, '...', this.pagesTotal - 4, this.pagesTotal - 3, this.pagesTotal - 2, this.pagesTotal - 1, this.pagesTotal];
             } else {
                this.pagebtnList = [1, '...', this.pageNum - 1, this.pageNum, this.pageNum + 1, '...', this.pagesTotal];
             }
          }
       },
 
       pageselect(pgn) {
          if (pgn == "...") return;
          this.pageNum = pgn;
          this.getPageList();
       },
 
       nextpage() {
          if (this.pageNum != this.pagesTotal) {
             this.pageNum += 1;
          }
          this.getPageList();
       },
 
       prepage() {
          if (this.pageNum != 1) {
             this.pageNum -= 1;
          }
          this.getPageList();
       },
       //图片展示
       showimg(src) {
          this.showimg_src = src;
      },
      async loadimgfun() {
          let w = 0;
          let h = 0;
          const img = new Image();
          img.src = this.showimg_src;
          
          const calcSize = (width, height) => {
              if (width > height) { 
                  this.show_img_width = 600;
                  this.show_img_height = Math.round(600 / width * height);
              } else {
                  this.show_img_height = 600;
                  this.show_img_width = Math.round(600 / height * width);
              }
          };

          await new Promise((resolve) => {
              img.onload = () => {
                  calcSize(img.width, img.height);
                  resolve();
              };
              if (img.complete) {
                   calcSize(img.width, img.height);
                   resolve();
              }
          });
      },
      closeshowimgbox() {
          this.showimg_src = "";
          this.show_img_width = 0;
          this.show_img_height = 0;
      },
      formatPrice(price) {
         if (price == null || price === '') return '0.00';
         return (Number(price) / 100).toFixed(2);
      },
      getClassName(status) {
          switch (status) {
              case 0:
                  return "is_close";
              case 1:
                  return "is_open";
              case 2:
                  return "is_none";
          }
      },
      getRoomTypeString(roomType){
               switch (roomType) {
                  case "1":
                      return "大床房";
                  case "2":
                      return "主题房";
                  case "3":
                      return "标间";
                  case "4":
                      return "单间";
              }
      },
      getRoomWindowTypeString(roomWindowType){
               switch (roomWindowType) {
                  case "1":
                      return "有窗";
                  case "2":
                      return "无窗";
                  case "3":
                      return "部分有窗";
              }
      },
      getRoomBedTypeString(roomBedType){
               switch (roomBedType) {
                  case "1":
                      return "大床";
                  case "2":
                      return "小床";
                  case "3":
                      return "单人床";
                  case "4":
                      return "双人床";
                  case "5":
                      return "混合";
              }
      },
    }
 }
 </script>
 
 <style scoped>
 #productpage {
    width: 100%;
    height: calc(100% - 40px);
    float: left;
    padding: 24px 40px;
    overflow-y: auto;
    box-sizing: border-box;
 }
 
 #productpage .con_top {
    width: 100%;
    height: 44px;
    float: left;
    margin-bottom: 16px;
 }
 
 #productpage .con_top button {
    height: 40px;
    padding: 0 24px;
    float: left;
    background: linear-gradient(135deg, #12ab04d4, #0d8a03);
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 12px rgba(18,171,4,0.25);
 }
 
 #productpage .con_top button:hover {
    background: linear-gradient(135deg, #17cf07d4, #12ab04d4);
    box-shadow: 0 6px 16px rgba(18,171,4,0.35);
    transform: translateY(-1px);
 }

 #productpage .serchbox {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
    margin-bottom: 20px;
 }

 #productpage .serch_form {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
 }

 #productpage .serch_item {
    display: flex;
    align-items: center;
 }

 #productpage .serch_item label {
    font-size: 14px;
    color: #555;
    margin-right: 8px;
    white-space: nowrap;
    font-weight: 500;
 }

 #productpage .serch_item input,
 #productpage .serch_item select {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    color: #333;
    min-width: 150px;
    transition: border-color 0.2s, box-shadow 0.2s;
    background: #fff;
 }

 #productpage .serch_item input:focus,
 #productpage .serch_item select:focus {
    border-color: #12ab04d4;
    box-shadow: 0 0 0 3px rgba(18,171,4,0.08);
 }

 #productpage .serch_btn {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
 }

 #productpage .serch_btn a {
    text-decoration: none;
    height: 36px;
    line-height: 36px;
    padding: 0 18px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    display: inline-block;
    text-align: center;
 }

 #productpage .serch_btn .btn-search {
    background: linear-gradient(135deg, #12ab04d4, #0d8a03);
    color: #fff;
    border: none;
    box-shadow: 0 3px 8px rgba(18,171,4,0.2);
 }

 #productpage .serch_btn .btn-search:hover {
    box-shadow: 0 5px 12px rgba(18,171,4,0.3);
    transform: translateY(-1px);
 }

 #productpage .serch_btn .btn-reset {
    background-color: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
 }

 #productpage .serch_btn .btn-reset:hover {
    color: #12ab04d4;
    border-color: #12ab04d4;
    background-color: #f0f9eb;
 }

 #productpage .tablelist {
    width: 100%;
    float: left;
 }
 
 #productpage .tablelist .content {
    width: 100%;
    float: left;
 }
 
 #productpage .tablelist .content .tablebox {
    width: 100%;
    float: left;
 }

 #productpage .tablelist .content .tablebox .item {
    width: calc(25% - 16px);
    float: left;
    margin: 8px;
    border-radius: 12px;
    padding: 0;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    position: relative;
    transition: all 0.3s;
 }

 #productpage .tablelist .content .tablebox .item:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    transform: translateY(-4px);
 }

 #productpage .tablelist .content .tablebox .item .imgbox {
    width: 100%;
    height: 200px;
    overflow: hidden;
 }

 #productpage .tablelist .content .tablebox .item .imgbox img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
 }

 #productpage .tablelist .content .tablebox .item:hover .imgbox img {
    transform: scale(1.05);
 }

 #productpage .tablelist .content .tablebox .item .roomStatus {
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 4px 12px;
    line-height: 1.4;
    text-align: center;
    color: #fff;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
 }

 #productpage .tablelist .content .tablebox .item.is_close .roomStatus {
    background: linear-gradient(135deg, #c0410e, #e05a30);
 }
 #productpage .tablelist .content .tablebox .item.is_open .roomStatus {
    background: linear-gradient(135deg, #2f8909, #4caf50);
 }
 #productpage .tablelist .content .tablebox .item.is_none .roomStatus {
    background: linear-gradient(135deg, #757575, #9e9e9e);
 }

 #productpage .tablelist .content .tablebox .item .room-info {
    padding: 14px 16px;
 }

 #productpage .tablelist .content .tablebox .item .roomName {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 8px;
    color: #333;
 }

 #productpage .tablelist .content .tablebox .item .otherInfo {
    width: 100%;
    font-size: 12px;
    line-height: 1.6;
    margin-bottom: 10px;
    color: #999;
 }

 #productpage .tablelist .content .tablebox .item .orderinfo {
    width: 100%;
    height: 36px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
 }

 #productpage .tablelist .content .tablebox .item .orderinfo .roomSales {
    font-size: 13px;
    color: #999;
 }

 #productpage .tablelist .content .tablebox .item .orderinfo .roomSales font {
    color: #333;
    font-weight: 600;
    margin-left: 4px;
 }

 #productpage .tablelist .content .tablebox .item .orderinfo .pice {
    font-size: 13px;
    color: #999;
 }

 #productpage .tablelist .content .tablebox .item .orderinfo .pice font {
    color: #e57834;
    font-size: 18px;
    font-weight: 700;
 }

 #productpage .tablelist .content .tablebox .item .btnbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 16px 16px;
 }

 #productpage .tablelist .content .tablebox .item .btnbox a {
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    transition: all 0.2s;
    font-weight: 500;
 }

 #productpage .tablelist .content .tablebox .item .btnbox a.btn-edit {
    background: linear-gradient(135deg, #e37806, #f09a30);
 }
 #productpage .tablelist .content .tablebox .item .btnbox a.btn-edit:hover {
    box-shadow: 0 3px 8px rgba(227,120,6,0.3);
 }

 #productpage .tablelist .content .tablebox .item .btnbox a.btn-del {
    background: linear-gradient(135deg, #d81d1d, #e55050);
 }
 #productpage .tablelist .content .tablebox .item .btnbox a.btn-del:hover {
    box-shadow: 0 3px 8px rgba(216,29,29,0.3);
 }

 #productpage .tablelist .content .tablebox .item .btnbox a.btn-select {
    background: linear-gradient(135deg, #12ab04d4, #17cf07d4);
 }
 #productpage .tablelist .content .tablebox .item .btnbox a.btn-select:hover {
    box-shadow: 0 3px 8px rgba(18,171,4,0.3);
 }

 #productpage .tablelist .content .tablebox .item .btnbox a.btn-open {
    background: linear-gradient(135deg, #04920e, #0bb818);
 }
 #productpage .tablelist .content .tablebox .item .btnbox a.btn-open:hover {
    box-shadow: 0 3px 8px rgba(4,146,14,0.3);
 }

 #productpage .tablelist .content .tablebox .item .btnbox a.btn-close {
    background: linear-gradient(135deg, #757575, #9e9e9e);
 }
 #productpage .tablelist .content .tablebox .item .btnbox a.btn-close:hover {
    box-shadow: 0 3px 8px rgba(117,117,117,0.3);
 }

 #productpage .tablelist .content .tablebox .item .btnbox a.btn-none {
    background: linear-gradient(135deg, #36a7be, #4fc3d8);
 }
 #productpage .tablelist .content .tablebox .item .btnbox a.btn-none:hover {
    box-shadow: 0 3px 8px rgba(54,167,190,0.3);
 }

 .no_date {
    width: 100%;
    text-align: center;
    padding: 60px 0;
    color: #ccc;
    font-size: 15px;
 }

 #productpage .tablelist .content .footer {
    width: 100%;
    float: left;
    text-align: center;
    margin-top: 24px;
    padding-bottom: 20px;
 }
 
 #productpage .tablelist .content .footer a {
    text-decoration: none;
    color: #555;
    display: inline-block;
    font-size: 14px;
    min-width: 34px;
    height: 34px;
    line-height: 34px;
    border: 1px solid #dcdfe6;
    margin: 4px 3px;
    background-color: #fff;
    border-radius: 6px;
    transition: all 0.2s;
 }

 #productpage .tablelist .content .footer a:hover {
    color: #12ab04d4;
    border-color: #12ab04d4;
 }
 
 #productpage .tablelist .content .footer a.nextbtn,
 #productpage .tablelist .content .footer a.prebtn {
    border: none;
    background: linear-gradient(135deg, #12ab04d4, #0d8a03);
    color: #fff;
    padding: 0 14px;
    box-shadow: 0 3px 8px rgba(18,171,4,0.2);
 }

 #productpage .tablelist .content .footer a.nextbtn:hover,
 #productpage .tablelist .content .footer a.prebtn:hover {
    box-shadow: 0 5px 12px rgba(18,171,4,0.3);
    transform: translateY(-1px);
 }
 
 #productpage .tablelist .content .footer a.active_page {
    border: none;
    background: linear-gradient(135deg, #e57834, #d06520);
    color: #fff;
    box-shadow: 0 3px 8px rgba(229,120,52,0.3);
 }
 
 #productpage .tablelist .content .footer a.is_sheng {
    border: none;
    background-color: transparent;
 }

 /* 全屏预览样式 */
#showimgbox {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10001; 
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
}
#showimgbox img {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 6px;
}
#showimgbox a {
  width: auto;
  height: 40px;
  position: absolute;
  top: 10px;
  right: 10px;
  display: block;
  color: #fff;
  text-align: center;
  line-height: 40px;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  background: rgba(0,0,0,0.4);
  padding: 0 16px;
  border-radius: 20px;
  transition: background 0.3s;
}
#showimgbox a:hover {
  background: rgba(0,0,0,0.6);
}
 </style>